import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";

function WelcomeLetterPreview({
  isOpen,
  onClose,
  htmlContent,
}) {
  return (
    <BasicModal
      popupOpen={isOpen}
      popupCloseHandler={onClose}
      isCross={true}
      heading="Welcome Letter Preview"
      popupSize="col-8"
      bodyMessage={
        <div className="welcome-letter-preview-wrapper">
          <div
            className="welcome-letter-preview-letter-only"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
          {/* <p className="welcome-letter-preview-note mb-0 mt-2">
            Skip button is shown on the STB device and is not part of this letter HTML.
          </p> */}
        </div>
      }
    />
  );
}

export default WelcomeLetterPreview;
